import {
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Paper,
  TextField,
  Typography
} from '@mui/material'
import React from 'react'
import { useStyles } from './styles'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import { ISearchWarehouse } from '../../../interfaces/Warehouse/Warehouse'

interface AlmacenSearchProps {
  handleBusqueda: any
  busqueda: ISearchWarehouse
  handleResetBusqueda: any
  handleCrearAlmacen?: any
  handleFetchFilteredData: any
}

export const SearchAlmacen: React.FC<AlmacenSearchProps> = ({
  handleBusqueda,
  busqueda,
  handleResetBusqueda,
  handleFetchFilteredData,
  handleCrearAlmacen
}) => {
  const classes = useStyles()
  return (
    <Container maxWidth='xl'>
      <Paper elevation={1}>
        <form className='' noValidate autoComplete='off'>
          <FormControl component='fieldset' className={classes.formControl}>
            <Typography variant='h5' component='h5'></Typography>
            <FormGroup row>
              <FormControlLabel
                control={
                  <TextField
                    id='warehouseName'
                    label='Nombre Almacén'
                    onChange={handleBusqueda}
                    name='warehouseName'
                    value={busqueda.warehouseName}
                  />
                }
                label=''
              />
              <FormControlLabel
                control={
                  <TextField
                    id='warehouseCode'
                    label='Código Almacén'
                    onChange={handleBusqueda}
                    name='warehouseCode'
                    value={busqueda.warehouseCode}
                  />
                }
                label=''
              />
              <div>
                <IconButton color='primary' onClick={handleResetBusqueda}>
                  <RotateLeftIcon />
                </IconButton>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleFetchFilteredData}
                  style={{ marginLeft: 10 }}
                >
                  Buscar
                </Button>
                <Button
                  variant='contained'
                  onClick={handleCrearAlmacen}
                  style={{ marginLeft: 10 }}
                >
                  Crear
                </Button>
                {/* <Button
                  disabled={isSelectedId}
                  variant='contained'
                  color='secondary'
                  onClick={handleOpenDelete}
                  style={{ marginLeft: 10 }}
                >
                  Eliminar
                </Button>
                {hadleOpenView && (
                  <Button
                    disabled={isSelectedId}
                    variant='contained'
                    color='primary'
                    onClick={hadleOpenView}
                    style={{ marginLeft: 10 }}
                  >
                    Ver
                  </Button>
                )} */}
              </div>
            </FormGroup>
          </FormControl>
        </form>
      </Paper>
    </Container>
  )
}
